import { removeAxiosAuth, setAxiosAuth } from "@/utils/api";
import { ADMIN_REFRESH_TOKEN_KEY, ADMIN_TOKEN_KEY } from "@/utils/constants";
import { toNumber } from "@/utils/number";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const isDevMode = process.env.REACT_APP_APP_ENV === "DEV";
export const AUTH_COOKIE_EXPIRES_DAYS = toNumber(process.env.REACT_APP_AUTH_COOKIE_EXPIRES_DAYS) || 30;

/**
 * Sets the access and refresh tokens in cookies and updates the Axios authentication configuration.
 *
 * @param {string} accessToken - The access token to set.
 * @param {string} refreshToken - The refresh token to set.
 */
export const setToken = (accessToken: string, refreshToken: string) => {
  const options: Cookies.CookieAttributes = { expires: AUTH_COOKIE_EXPIRES_DAYS };

  // Local development runs over plain http, where a `secure` cookie is dropped.
  if (!isDevMode) {
    options.secure = true;
    options.sameSite = "strict";
  }

  Cookies.set(ADMIN_TOKEN_KEY, accessToken, options);
  Cookies.set(ADMIN_REFRESH_TOKEN_KEY, refreshToken, options);
  setAxiosAuth();
};

/**
 * Removes the access and refresh tokens from cookies and updates the Axios authentication configuration.
 */
export const removeToken = () => {
  Cookies.remove(ADMIN_TOKEN_KEY);
  Cookies.remove(ADMIN_REFRESH_TOKEN_KEY);
  removeAxiosAuth();
};

/**
 * Verifies if a given token is still valid based on its expiration time.
 *
 * @param {string} token - The token to verify.
 * @returns {boolean} - `true` if the token is still valid, `false` otherwise.
 */
export function verifyToken(token: string) {
  try {
    const decoded = jwtDecode<{ exp: number }>(token);
    return decoded.exp > new Date().getTime() / 1000;
  } catch (e) {
    return false;
  }
}
